module.exports = __webpack_public_path__ + "img/07_Energetic Driver.8af35d13.svg";